'use client';

export function mysteryRoomPlayerColor(isSelf: boolean): number {
  return isSelf ? 0xf59e0b : 0x22d3ee;
}

export function mysteryRoomPlayerStrokeColor(isSelf: boolean): number {
  return isSelf ? 0xfffbeb : 0xecfeff;
}
